import { Link } from 'react-router-dom';
import './LegalPage.css';

const EFFECTIVE_DATE = 'August 13, 2026';

function TermsAndConditions() {
  const backgroundImage = '/background.jpg';

  return (
    <div className="legal-page" style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center' }}>
      <div className="legal-content">
        <Link to="/" className="back-link">← Back to Home</Link>
        <h1>Terms and Conditions</h1>
        <p className="last-updated">Effective Date: {EFFECTIVE_DATE}</p>

        <p>
          THESE TERMS AND CONDITIONS CONTAIN A BINDING INDIVIDUAL ARBITRATION PROVISION AND A WAIVER
          OF CLASS, COLLECTIVE AND REPRESENTATIVE RELIEF AT ARTICLE 17, WHICH AFFECT YOUR LEGAL
          RIGHTS AND REMEDIES, AND WHICH YOU MAY REJECT IN ACCORDANCE WITH SECTION 17.6. THEY
          FURTHER CONTAIN DISCLAIMERS OF WARRANTY AT ARTICLE 13 AND LIMITATIONS UPON LIABILITY AT
          ARTICLE 14. READ THEM IN THEIR ENTIRETY PRIOR TO ACCESSING OR USING THE APPLICATION.
        </p>

        <section>
          <h2>1. Definitions</h2>
          <p>
            1.1 For all purposes of and under this Agreement, the following capitalised terms shall
            have the respective meanings ascribed to them in this Article 1, and cognate expressions
            shall be construed accordingly.
          </p>
          <p>
            1.2 "Agreement" means these Terms and Conditions, together with the Privacy Policy
            incorporated herein by reference pursuant to Section 2.4, in each case as amended,
            supplemented, restated or otherwise modified from time to time in accordance with
            Section 19.7.
          </p>
          <p>
            1.3 "Applicable Law" means any and all statutes, rules, regulations, orders, ordinances,
            judgments, decrees and other legal requirements of any governmental or regulatory
            authority having jurisdiction over the subject matter hereof.
          </p>
          <p>
            1.4 "Application" means the mobile software application entitled Last One Standing,
            together with any and all other mobile software applications published from time to time
            by the Company, in each case including all constituent object code, source code, audio,
            visual and audiovisual elements, textual matter, databases, interfaces, updates, upgrades,
            patches, modifications, releases and derivative works thereof.
          </p>
          <p>
            1.5 "Company", "we", "us" and "our" mean tnysocial LLC, a limited liability company
            organised and existing under the laws of the State of Delaware, United States of America,
            together with its successors and permitted assigns.
          </p>
          <p>
            1.6 "Content" means all puzzles, prompts, rankings, values, photographic and pictorial
            matter, marks, designs, layouts and other materials made available in, through or by means
            of the Application, whether proprietary to the Company or licensed or otherwise lawfully
            used by it.
          </p>
          <p>
            1.7 "Subscription" means the auto-renewing subscription entitlement designated within the
            Application as "premium", procured exclusively through the Store.
          </p>
          <p>
            1.8 "Store" means the Apple App Store operated by Apple Inc. and its relevant
            subsidiaries and affiliates.
          </p>
          <p>
            1.9 "Virtual Items" means coins, credits, balances and any other intangible in-application
            tokens, denominations or units of account, howsoever denominated, which may be acquired,
            accrued, consumed or forfeited within the Application.
          </p>
          <p>
            1.10 "You" and "Your" mean the natural person accessing, downloading, installing or
            otherwise using the Application, and, where such person is a minor, additionally the
            parent or legal guardian assenting hereto on such person's behalf pursuant to Section 3.3.
          </p>
        </section>

        <section>
          <h2>2. Acceptance and Formation of Agreement</h2>
          <p>
            2.1 This Agreement constitutes a legally binding contract by and between You and the
            Company governing Your access to and use of the Application. By downloading, installing,
            accessing or otherwise using the Application, or by any continued use thereof following
            the Effective Date, You acknowledge that You have read and understood this Agreement and
            You unconditionally and irrevocably assent to be bound by each and every provision hereof.
          </p>
          <p>
            2.2 If You do not assent to any provision of this Agreement, You must immediately cease
            all access to and use of the Application and delete the same from any and all devices
            within Your possession or control.
          </p>
          <p>
            2.3 The Company transacts with You solely in its capacity as a limited liability company.
            No member, manager, officer, employee or agent of the Company assumes any personal
            obligation or liability hereunder.
          </p>
          <p>
            2.4 The <Link to="/privacy">Privacy Policy</Link> is hereby incorporated into and made a
            part of this Agreement by this reference with the same force and effect as though fully
            set forth herein.
          </p>
        </section>

        <section>
          <h2>3. Eligibility and Capacity</h2>
          <p>
            3.1 You represent, warrant and covenant that You have attained the age of thirteen (13)
            years, or such greater age as may be prescribed by the Applicable Law of Your jurisdiction
            of residence as the minimum age at which a natural person may lawfully consent to the
            processing of personal data, which age is sixteen (16) years in certain Member States of
            the European Union.
          </p>
          <p>
            3.2 The Application is not directed to, nor intended for use by, natural persons under the
            age of thirteen (13) years.
          </p>
          <p>
            3.3 If You have not attained the age of eighteen (18) years, You represent and warrant that
            Your parent or legal guardian has reviewed this Agreement, has consented to Your use of the
            Application, and has assented to this Agreement on Your behalf, and that such parent or
            legal guardian accepts responsibility for Your compliance herewith.
          </p>
          <p>
            3.4 You further represent and warrant that You are not barred from receiving the
            Application under Applicable Law and that You possess full legal capacity to enter into
            this Agreement.
          </p>
        </section>

        <section>
          <h2>4. Absence of Registered Accounts; Assumption of Risk</h2>
          <p>
            4.1 The Application does not provide for, and the Company does not maintain, any system of
            registered user accounts. The Company does not solicit, require or collect any name,
            electronic mail address, telephone number or other direct identifier as a condition of use.
          </p>
          <p>
            4.2 Progression, statistics, streaks and Virtual Items are associated exclusively with an
            opaque randomly generated identifier provisioned upon the device. You expressly acknowledge
            and assume the risk that deletion of the Application, resetting or erasure of device data,
            transfer to a replacement device, or any similar event may result in the irretrievable loss
            of any and all such progression, statistics, streaks and Virtual Items, and that the Company
            shall bear no obligation or liability whatsoever in respect thereof.
          </p>
          <p>
            4.3 Notwithstanding Section 4.2, a Subscription is associated with Your Store account rather
            than with the Company, and may accordingly be reinstated by means of the restoration
            function made available within the Application.
          </p>
        </section>

        <section>
          <h2>5. Grant and Scope of Licence; Reservation of Rights</h2>
          <p>
            5.1 Subject to Your continuing compliance with each and every term and condition hereof,
            the Company hereby grants to You a limited, personal, revocable, non-exclusive,
            non-transferable, non-sublicensable and non-assignable licence to download, install and
            use one (1) copy of the Application in object code form upon any Apple-branded device that
            You own or control, solely for Your personal, private, non-commercial entertainment
            purposes, and for no other purpose whatsoever.
          </p>
          <p>
            5.2 The Application is licensed, and not sold, to You. All right, title and interest in and
            to the Application and the Content, including all intellectual property rights subsisting
            therein, are and shall remain vested in the Company or its respective licensors. No right,
            title, interest, licence or immunity is granted or is to be implied hereunder by estoppel or
            otherwise save as expressly set forth in Section 5.1, and all rights not expressly granted
            are hereby reserved.
          </p>
        </section>

        <section>
          <h2>6. Restrictions upon Use</h2>
          <p>
            6.1 You shall not, and shall not permit, authorise, procure or suffer any third party to,
            directly or indirectly:
          </p>
          <ul>
            <li>(a) copy, reproduce, modify, adapt, translate, publish, transmit, distribute, perform,
            display, or create derivative works of the Application or the Content, in whole or in part;</li>
            <li>(b) reverse engineer, decompile, disassemble, decrypt, or otherwise attempt to derive or
            gain access to the source code, algorithms or underlying structure of the Application, save
            and except to the extent that such conduct is permitted by Applicable Law notwithstanding
            this restriction;</li>
            <li>(c) remove, obliterate, obscure or alter any proprietary, copyright, trademark or other
            notice affixed to or contained within the Application;</li>
            <li>(d) rent, lease, lend, sell, resell, sublicense, assign, distribute, timeshare, or
            otherwise transfer or make available the Application to any third party;</li>
            <li>(e) exploit the Application for any commercial, revenue-generating or promotional
            purpose without the prior express written consent of the Company;</li>
            <li>(f) employ any robot, spider, scraper, bot, emulator, modified or unauthorised client,
            memory-editing utility, automation framework or other automated or manual process to access
            the Application, to accrue or manipulate Virtual Items, or to influence, falsify or
            interfere with any result, timing, ranking or statistic;</li>
            <li>(g) circumvent, disable, degrade, defeat or otherwise interfere with any advertising,
            purchasing, metering, security, authentication or access-control mechanism forming part of
            or associated with the Application;</li>
            <li>(h) extract, harvest, scrape, index, cache, aggregate or republish any Content or data
            comprised in or obtained from the Application;</li>
            <li>(i) interfere with, disrupt, overburden, or impair the operation or integrity of the
            Application or of any server, network or infrastructure supporting the same, or attempt to
            obtain unauthorised access thereto or to the data of any other user; or</li>
            <li>(j) use the Application in contravention of any Applicable Law or in a manner that
            infringes, misappropriates or violates the rights of any third party.</li>
          </ul>
          <p>
            6.2 The Company may, in its sole and absolute discretion and without prior notice or
            liability, suspend, restrict or terminate Your access to the Application where it
            reasonably apprehends any breach of this Article 6.
          </p>
        </section>

        <section>
          <h2>7. Virtual Items</h2>
          <p>
            7.1 Virtual Items constitute a limited, personal, revocable, non-transferable licence to
            use a feature of the Application. Virtual Items do not constitute property, currency, legal
            tender, a stored-value instrument, a security, a commodity, a deposit, or any other right,
            title or interest of any nature, and confer no proprietary interest whatsoever upon You.
          </p>
          <p>
            7.2 Virtual Items possess no monetary value, are not redeemable for money, goods, services
            or any item of value outside the Application, and may not be sold, purchased from any third
            party, transferred, assigned, gifted, bartered, exchanged, bequeathed or otherwise disposed
            of, whether for consideration or otherwise.
          </p>
          <p>
            7.3 The Company reserves the unfettered right, exercisable in its sole and absolute
            discretion, at any time and without prior notice, compensation, refund or liability, to
            create, regulate, modify, revalue, suspend, forfeit, reduce, extinguish or discontinue
            Virtual Items in whole or in part, and to alter the rates, terms and conditions upon which
            Virtual Items may be accrued or consumed.
          </p>
          <p>
            7.4 Virtual Items are recorded locally upon the device and are irretrievably extinguished
            upon deletion of the Application. All licences in respect of Virtual Items terminate
            automatically and without notice upon termination of this Agreement, howsoever occasioned.
          </p>
        </section>

        <section>
          <h2>8. Subscriptions, Automatic Renewal and Billing</h2>
          <p>
            8.1 The Application makes available an optional Subscription which, whilst subsisting,
            confers the removal of advertising, access to the game mode designated "Endless", and an
            enhanced rate of accrual of Virtual Items in respect of daily puzzles.
          </p>
          <p>
            8.2 The price and duration of each Subscription offering are disclosed within the
            Application prior to consummation of the transaction, and may vary by territory, by
            offering and from time to time.
          </p>
          <p>
            8.3 Payment shall be charged to Your Store account upon Your confirmation of purchase.
          </p>
          <p>
            8.4 EACH SUBSCRIPTION RENEWS AUTOMATICALLY FOR SUCCESSIVE PERIODS OF EQUAL DURATION AND AT
            THE THEN-PREVAILING PRICE UNLESS AND UNTIL AUTOMATIC RENEWAL IS DISABLED NOT LESS THAN
            TWENTY-FOUR (24) HOURS PRIOR TO THE EXPIRATION OF THE THEN-CURRENT PERIOD. YOUR STORE
            ACCOUNT WILL BE CHARGED FOR RENEWAL WITHIN TWENTY-FOUR (24) HOURS PRIOR TO SUCH EXPIRATION.
          </p>
          <p>
            8.5 Management, modification and cancellation of a Subscription are effected exclusively
            through the account settings of the Store. Deletion of the Application does not of itself
            operate to cancel a Subscription or to terminate any obligation to pay.
          </p>
          <p>
            8.6 Cancellation operates prospectively only, takes effect at the conclusion of the
            then-current period, and does not give rise to any refund, rebate or apportionment in
            respect of any period already paid for. The Subscription entitlement subsists until the
            conclusion of such period.
          </p>
          <p>
            8.7 ALL REFUNDS ARE ADMINISTERED EXCLUSIVELY BY APPLE INC. IN ACCORDANCE WITH THE APPLE
            MEDIA SERVICES TERMS AND CONDITIONS. THE COMPANY IS NOT THE MERCHANT OF RECORD, DOES NOT
            PROCESS PAYMENTS, AND POSSESSES NO CAPACITY TO ISSUE, PROCURE OR COMPEL ANY REFUND IN
            RESPECT OF ANY TRANSACTION EFFECTED THROUGH THE STORE.
          </p>
          <p>
            8.8 In the event that a Subscription has been procured but the corresponding entitlement
            has not been conferred within the Application, You shall first invoke the restoration
            function made available within the Application, and failing resolution thereby may notify
            the Company in accordance with Article 18.
          </p>
        </section>

        <section>
          <h2>9. Advertising</h2>
          <p>
            9.1 The Application is made available without charge and is supported in part by the display
            of advertising to users not holding a subsisting Subscription. Such advertising is served by
            third-party advertising networks.
          </p>
          <p>
            9.2 The Company neither originates, selects, endorses, verifies nor controls the substance
            of third-party advertising, and disclaims any and all liability in respect of the goods,
            services, representations, offers or destinations promoted thereby. Any dealings between You
            and any advertiser are solely between You and such advertiser.
          </p>
          <p>
            9.3 The processing of data in connection with advertising is described in the{' '}
            <Link to="/privacy">Privacy Policy</Link>.
          </p>
        </section>

        <section>
          <h2>10. Proprietary Rights</h2>
          <p>
            10.1 The Application and the Content, and all copyrights, database rights, trademarks,
            service marks, trade names, trade dress, design rights, patents, know-how, trade secrets and
            other intellectual and industrial property rights subsisting therein or relating thereto,
            whether registered or unregistered and wheresoever subsisting, are and shall at all times
            remain the exclusive property of the Company or of its respective licensors.
          </p>
          <p>
            10.2 The name "tnysocial", the name "Last One Standing", and all associated logos, devices
            and marks are proprietary to the Company. No licence to use the same is granted hereunder,
            and You shall not use, register or seek to register any identical or confusingly similar
            mark.
          </p>
        </section>

        <section>
          <h2>11. Third-Party Names, Images and Likenesses; Notification Procedure</h2>
          <p>
            11.1 The Application constitutes a work of trivia, commentary, criticism and entertainment
            concerning persons of public prominence. It refers to such persons by name and incorporates
            photographic matter depicting them, in each case for purposes of identification, reference,
            commentary, criticism and entertainment.
          </p>
          <p>
            11.2 NO PERSON NAMED OR DEPICTED WITHIN THE APPLICATION HAS SPONSORED, ENDORSED, APPROVED,
            LICENSED, CERTIFIED OR IS IN ANY MANNER AFFILIATED OR ASSOCIATED WITH THE APPLICATION OR
            WITH THE COMPANY, AND NOTHING CONTAINED IN THE APPLICATION SHALL BE CONSTRUED AS ASSERTING,
            IMPLYING OR SUGGESTING ANY SUCH SPONSORSHIP, ENDORSEMENT, APPROVAL, LICENCE, CERTIFICATION,
            AFFILIATION OR ASSOCIATION.
          </p>
          <p>
            11.3 Rankings, values, orderings, statistics and other assertions of fact appearing within
            the Content are compiled from sources available in the public domain, are presented for
            entertainment purposes only, and may be inaccurate, incomplete, outdated, approximate,
            estimated, disputed or subjective. The same do not constitute representations of fact and
            shall not be relied upon for any purpose.
          </p>
          <p>
            11.4 Photographic matter appearing within the Application may be licensed from third parties
            or otherwise used in reliance upon exceptions, limitations and defences available under
            Applicable Law, including without limitation the doctrine of fair use. All rights of third
            parties subsisting in such matter remain vested in the respective proprietors thereof.
          </p>
          <p>
            11.5 Any person asserting that Content appearing within the Application infringes, violates
            or misappropriates any right of publicity, right of personality, moral right, copyright or
            other proprietary right, or otherwise ought not to be used, may deliver written notification
            to the Company in accordance with Article 18, specifying (a) the identity of the person or
            work concerned, (b) the specific Content complained of and sufficient particulars to enable
            its location, (c) the legal and factual basis of the assertion, (d) the identity, capacity
            and contact particulars of the notifying party, and (e) a statement that the notification is
            made in good faith. The Company shall review each such notification with reasonable
            expedition and shall remove or amend the Content complained of where it considers such
            course appropriate. Nothing in this Section 11.5 shall constitute an admission of liability
            or a waiver of any right, defence or remedy of the Company, all of which are expressly
            reserved.
          </p>
        </section>

        <section>
          <h2>12. Modification, Interruption and Discontinuation</h2>
          <p>
            12.1 Operation of the Application is contingent upon the availability of network
            connectivity, the daily puzzle being delivered by remote means. The Company does not warrant
            uninterrupted, timely, secure or error-free operation.
          </p>
          <p>
            12.2 You acknowledge and agree that the Company may at any time, in its sole and absolute
            discretion and without prior notice or liability: (a) deliver updates, upgrades, patches and
            modifications, including such as are applied automatically and over the air; (b) place the
            Application into a state of maintenance whereby access is temporarily withheld; (c) stipulate
            a minimum permissible version and withhold access from installations not conforming thereto;
            (d) introduce, vary, suspend, restrict or withdraw any feature, mode, Content or
            functionality; and (e) discontinue the Application in whole or in part, permanently or
            temporarily.
          </p>
        </section>

        <section>
          <h2>13. Disclaimer of Warranties</h2>
          <p>
            13.1 TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, THE APPLICATION AND THE CONTENT ARE
            PROVIDED "AS IS", "AS AVAILABLE" AND "WITH ALL FAULTS", WITHOUT WARRANTY, REPRESENTATION,
            CONDITION OR UNDERTAKING OF ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY OR ARISING BY
            OPERATION OF LAW, COURSE OF DEALING, COURSE OF PERFORMANCE OR USAGE OF TRADE.
          </p>
          <p>
            13.2 WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, THE COMPANY EXPRESSLY DISCLAIMS ANY
            AND ALL IMPLIED WARRANTIES AND CONDITIONS OF MERCHANTABILITY, SATISFACTORY QUALITY, FITNESS
            FOR A PARTICULAR OR GENERAL PURPOSE, TITLE, QUIET ENJOYMENT, ACCURACY, AND NON-INFRINGEMENT,
            AND FURTHER DISCLAIMS ANY WARRANTY THAT THE APPLICATION WILL BE UNINTERRUPTED, AVAILABLE,
            SECURE, FREE FROM ERROR, DEFECT, VIRUS OR OTHER HARMFUL COMPONENT, OR THAT ANY DEFECT WILL
            BE CORRECTED.
          </p>
          <p>
            13.3 NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY THE COMPANY OR ANY REPRESENTATIVE
            THEREOF SHALL CREATE ANY WARRANTY.
          </p>
          <p>
            13.4 Certain jurisdictions do not permit the exclusion of implied warranties or of statutory
            consumer guarantees, and to the extent that any such exclusion is impermissible, the
            foregoing exclusions shall apply to the maximum extent permitted and shall otherwise be
            severed. Nothing herein purports to exclude or restrict any right or remedy conferred upon a
            consumer by Applicable Law which may not lawfully be excluded or restricted.
          </p>
        </section>

        <section>
          <h2>14. Limitation of Liability</h2>
          <p>
            14.1 TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL THE COMPANY, NOR
            ANY OF ITS MEMBERS, MANAGERS, OFFICERS, EMPLOYEES, CONTRACTORS, AGENTS, LICENSORS,
            SUPPLIERS, SUCCESSORS OR ASSIGNS, BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
            CONSEQUENTIAL, EXEMPLARY, PUNITIVE OR AGGRAVATED DAMAGES WHATSOEVER, OR FOR ANY LOSS OF
            PROFITS, REVENUE, BUSINESS, ANTICIPATED SAVINGS, OPPORTUNITY, GOODWILL, REPUTATION, DATA,
            PROGRESSION, STATISTICS OR VIRTUAL ITEMS, HOWSOEVER ARISING AND WHETHER FOUNDED IN CONTRACT,
            TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY, BREACH OF STATUTORY DUTY, RESTITUTION OR
            OTHERWISE, AND WHETHER OR NOT THE COMPANY HAS BEEN ADVISED OF, OR OUGHT REASONABLY TO HAVE
            FORESEEN, THE POSSIBILITY THEREOF.
          </p>
          <p>
            14.2 TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, THE AGGREGATE LIABILITY OF THE
            COMPANY ARISING OUT OF OR IN CONNECTION WITH THIS AGREEMENT OR THE APPLICATION, WHETHER IN
            RESPECT OF ONE OR MORE CLAIMS AND HOWSOEVER ARISING, SHALL NOT EXCEED THE GREATER OF (A) THE
            AGGREGATE AMOUNT ACTUALLY PAID BY YOU TO THE COMPANY IN THE TWELVE (12) MONTHS IMMEDIATELY
            PRECEDING THE EVENT FIRST GIVING RISE TO THE CLAIM, AND (B) TWENTY-FIVE UNITED STATES
            DOLLARS (USD 25.00).
          </p>
          <p>
            14.3 The limitations and exclusions in this Article 14 are fundamental elements of the basis
            of the bargain between the parties, shall apply notwithstanding the failure of the essential
            purpose of any limited remedy, and shall survive termination of this Agreement.
          </p>
          <p>
            14.4 Nothing in this Agreement operates to exclude or limit liability for fraud or fraudulent
            misrepresentation, for death or personal injury occasioned by negligence, or for any other
            liability which may not lawfully be excluded or limited.
          </p>
        </section>

        <section>
          <h2>15. Provisions Required by Apple Inc.</h2>
          <p>
            15.1 You acknowledge and agree that this Agreement is concluded between You and the Company
            only, and not with Apple Inc., and that the Company alone is responsible for the Application
            and the Content thereof.
          </p>
          <p>
            15.2 Apple Inc. has no obligation whatsoever to furnish any maintenance or support services
            in respect of the Application.
          </p>
          <p>
            15.3 In the event of any failure of the Application to conform to any applicable warranty,
            You may notify Apple Inc., and Apple Inc. will refund the purchase price (if any) of the
            Application to You. To the maximum extent permitted by Applicable Law, Apple Inc. shall have
            no other warranty obligation whatsoever with respect to the Application.
          </p>
          <p>
            15.4 The Company, and not Apple Inc., is responsible for addressing any claim of You or any
            third party relating to the Application or Your possession or use thereof, including without
            limitation (a) product liability claims, (b) any claim that the Application fails to conform
            to any applicable legal or regulatory requirement, and (c) claims arising under consumer
            protection, privacy or similar legislation.
          </p>
          <p>
            15.5 In the event of any third-party claim that the Application or Your possession and use
            thereof infringes that third party's intellectual property rights, the Company, and not Apple
            Inc., shall be solely responsible for the investigation, defence, settlement and discharge of
            such claim.
          </p>
          <p>
            15.6 You represent and warrant that You are not located in a country that is subject to a
            United States Government embargo or that has been designated by the United States Government
            as a "terrorist supporting" country, and that You are not listed on any United States
            Government list of prohibited or restricted parties.
          </p>
          <p>
            15.7 APPLE INC. AND ITS SUBSIDIARIES ARE THIRD-PARTY BENEFICIARIES OF THIS AGREEMENT AND,
            UPON YOUR ACCEPTANCE HEREOF, SHALL HAVE THE RIGHT (AND SHALL BE DEEMED TO HAVE ACCEPTED THE
            RIGHT) TO ENFORCE THIS AGREEMENT AGAINST YOU AS A THIRD-PARTY BENEFICIARY HEREOF.
          </p>
        </section>

        <section>
          <h2>16. Term, Termination and Survival</h2>
          <p>
            16.1 This Agreement takes effect upon Your first access to or use of the Application and
            continues in force until terminated in accordance with this Article 16.
          </p>
          <p>
            16.2 You may terminate this Agreement at any time by ceasing all use of the Application and
            deleting the same from all devices within Your possession or control.
          </p>
          <p>
            16.3 The Company may suspend or terminate this Agreement and Your access to the Application
            immediately, without prior notice, demand or judicial process, and without liability, where
            You are in breach hereof or where the Company reasonably considers such action necessary or
            expedient for the protection of the Application, the Company or any other user.
          </p>
          <p>
            16.4 Upon termination, the licence granted under Section 5.1 and all licences in respect of
            Virtual Items terminate forthwith and automatically.
          </p>
          <p>
            16.5 Articles 1, 4, 7, 10, 11, 13, 14, 15, 16, 17, 18 and 19, together with any other
            provision which by its nature ought to survive, shall survive the termination or expiration
            of this Agreement howsoever occasioned.
          </p>
        </section>

        <section>
          <h2>17. Governing Law, Dispute Resolution and Waiver of Class Relief</h2>
          <p>
            17.1 This Agreement, and any dispute, claim, controversy or cause of action arising out of or
            relating hereto or to the Application, whether sounding in contract, tort, statute or
            otherwise, shall be governed by and construed in accordance with the laws of the State of
            Delaware, United States of America, without regard to any conflict of laws principle that
            would require the application of the law of any other jurisdiction; provided, however, that
            where You are a consumer habitually resident in another jurisdiction, You retain the benefit
            of any mandatory provision of consumer protection law of that jurisdiction from which
            derogation by agreement is not permitted.
          </p>
          <p>
            17.2 Informal Resolution. As a condition precedent to the institution of any arbitration or
            other proceeding, the party asserting a dispute shall deliver written notice thereof pursuant
            to Article 18, setting out the nature and basis of the dispute and the relief sought. The
            parties shall thereafter negotiate in good faith with a view to resolution. Neither party may
            commence arbitration or other proceedings until thirty (30) days after delivery of such
            notice. Any applicable limitation period shall be tolled during such period.
          </p>
          <p>
            17.3 Agreement to Arbitrate. Save as provided in Section 17.5, any dispute, claim,
            controversy or cause of action not resolved pursuant to Section 17.2 shall be referred to and
            finally determined by binding individual arbitration administered by the American Arbitration
            Association in accordance with its Consumer Arbitration Rules then in force, which rules are
            deemed incorporated herein by reference. The arbitration shall be conducted before a single
            arbitrator. The seat of arbitration shall be the State of Delaware, provided that You may
            elect that any hearing be conducted by telephone, by videoconference, or at a location
            reasonably convenient to You, or that the matter be determined upon documents alone. Judgment
            upon the award rendered may be entered in any court of competent jurisdiction. Allocation of
            filing, administration and arbitrator fees shall be governed by the applicable rules.
          </p>
          <p>
            17.4 WAIVER OF CLASS AND REPRESENTATIVE RELIEF. ALL DISPUTES SHALL BE RESOLVED ON AN
            INDIVIDUAL BASIS ONLY. YOU AND THE COMPANY EACH IRREVOCABLY WAIVE ANY RIGHT TO COMMENCE,
            MAINTAIN, PARTICIPATE IN OR RECOVER UPON ANY CLASS, COLLECTIVE, CONSOLIDATED, COORDINATED,
            PRIVATE ATTORNEY GENERAL OR OTHER REPRESENTATIVE ACTION OR PROCEEDING, AND THE ARBITRATOR
            SHALL HAVE NO AUTHORITY TO CONSOLIDATE CLAIMS OR TO PRESIDE OVER ANY FORM OF REPRESENTATIVE
            PROCEEDING. If this Section 17.4 is held unenforceable in respect of any claim, that claim
            shall be severed and determined by a court of competent jurisdiction, and the remainder of
            this Article 17 shall continue in full force.
          </p>
          <p>
            17.5 Exceptions. Notwithstanding anything to the contrary contained herein, either party may
            (a) bring an individual action in a court of small claims having competent jurisdiction, and
            (b) seek injunctive, declaratory or other equitable relief in a court of competent
            jurisdiction in respect of the actual or threatened infringement, misappropriation or
            violation of intellectual property rights.
          </p>
          <p>
            17.6 RIGHT TO OPT OUT. You may reject the agreement to arbitrate contained in Sections 17.3
            and 17.4 by delivering written notice to the Company in accordance with Article 18, bearing
            the subject line "Arbitration Opt-Out", within thirty (30) days after the date upon which You
            first assent to this Agreement. Such notice shall be effective upon receipt. Rejection of the
            agreement to arbitrate shall not affect any other provision hereof, and the Company shall not
            treat You adversely by reason thereof. In the event of such rejection, or where the agreement
            to arbitrate is held inapplicable or unenforceable, the parties irrevocably submit to the
            exclusive jurisdiction of the state and federal courts sitting in the State of Delaware and
            waive any objection founded upon venue or forum non conveniens.
          </p>
          <p>
            17.7 This Article 17 shall survive termination of this Agreement.
          </p>
        </section>

        <section>
          <h2>18. Notices</h2>
          <p>
            18.1 Any notice, demand, notification or other communication required or permitted to be
            given hereunder shall be in writing and delivered by electronic mail to the Company at{' '}
            <a href="mailto:hello@tnysocial.com">hello@tnysocial.com</a>, and shall be deemed duly given
            upon transmission, absent notification of delivery failure.
          </p>
          <p>
            18.2 The Company may give notice to You by any reasonable means, including by posting upon
            this page or by notification within the Application, and such notice shall be deemed duly
            given upon posting or display.
          </p>
        </section>

        <section>
          <h2>19. Miscellaneous</h2>
          <p>
            19.1 Entire Agreement. This Agreement constitutes the entire agreement and understanding
            between the parties in respect of the subject matter hereof and supersedes all prior and
            contemporaneous agreements, understandings, representations and communications, whether oral
            or written.
          </p>
          <p>
            19.2 Severability. If any provision hereof is held invalid, illegal or unenforceable by a
            tribunal of competent jurisdiction, such provision shall be severed or, where permissible,
            construed so as to give effect to the intention of the parties to the maximum extent
            permitted, and the remaining provisions shall continue in full force and effect.
          </p>
          <p>
            19.3 No Waiver. No failure or delay by the Company in exercising any right, power or remedy
            shall operate as a waiver thereof, nor shall any single or partial exercise preclude any
            further exercise. No waiver shall be effective unless in writing and signed by the Company.
          </p>
          <p>
            19.4 Assignment. You shall not assign, novate, charge, subcontract or otherwise transfer this
            Agreement or any right or obligation hereunder, whether by operation of law or otherwise,
            without the prior written consent of the Company, and any purported assignment in
            contravention hereof shall be void ab initio. The Company may assign or novate this Agreement
            freely, including to an affiliate or in connection with any merger, acquisition,
            reorganisation or sale of all or substantially all of its assets.
          </p>
          <p>
            19.5 No Third-Party Beneficiaries. Save as expressly provided in Article 15, nothing herein
            confers upon any person other than the parties any right, benefit or remedy.
          </p>
          <p>
            19.6 Headings and Construction. Article and section headings are inserted for convenience of
            reference only and shall not affect construction. The words "include", "includes" and
            "including" shall be construed without limitation. No provision shall be construed against
            the Company by reason of its having drafted the same.
          </p>
          <p>
            19.7 Amendment. The Company reserves the right to amend, vary, supplement or replace this
            Agreement at any time. Where any such amendment is material, notice shall be given in
            accordance with Section 18.2 not less than thirty (30) days prior to the same taking effect,
            and the Effective Date appearing above shall be revised. Continued use of the Application
            following the date upon which any amendment takes effect constitutes assent thereto. If You
            do not assent, You must cease all use of the Application and, where applicable, cancel any
            Subscription through the Store.
          </p>
        </section>

        <section>
          <h2>20. Company Particulars</h2>
          <p>
            tnysocial LLC<br />
            A Delaware limited liability company<br />
            State of Delaware, United States of America<br />
            <a href="mailto:hello@tnysocial.com">hello@tnysocial.com</a>
          </p>
          <p>
            Reference is further made to the <Link to="/privacy">Privacy Policy</Link>, incorporated
            herein pursuant to Section 2.4.
          </p>
        </section>
      </div>
    </div>
  );
}

export default TermsAndConditions;
